const magicLine = () => {
  if (!document.getElementById('nav-main')) return;

  let leftPos, newWidth;
  const navList = document.getElementById('nav-main').querySelector('ul');
  const magicLine = document.createElement('li');
  magicLine.id = 'magic-line';
  navList.appendChild(magicLine);
  navList.classList.add('has-magic-line');

  Array.from(document.querySelectorAll('.nav-main > ul > li > a')).forEach((tabLink) => {
    tabLink.addEventListener('mouseenter', function() {
      if (tabLink.parentElement.classList.contains('sk-btn')) {
        magicLine.style.left = `${magicLine.dataset.origLeft ? magicLine.dataset.origLeft : 0}px`;
        magicLine.style.width = `${magicLine.dataset.origWidth ? magicLine.dataset.origWidth : 0}px`;
      }
      else {
        leftPos = this.offsetLeft;
        newWidth = this.parentNode.offsetWidth + 1;
        magicLine.style.left = `${leftPos}px`;
        magicLine.style.width = `${newWidth}px`;
      }
    });
  });

  document.querySelector('.nav-main > ul').addEventListener('mouseleave', function() {
    if (this.contains(document.activeElement)) {
      return;
    }
    magicLine.style.left = `${magicLine.dataset.origLeft ? magicLine.dataset.origLeft : 0}px`;
    magicLine.style.width = `${magicLine.dataset.origWidth ? magicLine.dataset.origWidth : 0}px`;
  })
}

export default magicLine;
